import { useState, useEffect, useRef } from "react";
import { GetMocktestQuestion } from "../../../Client/request";

export const useWritingQuestion = (quest, onQuestionLoaded) => {
  const [questData, setQuestData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [disabled, setDisabled] = useState(true);
  const onQuestionLoadedRef = useRef(onQuestionLoaded);

  useEffect(() => {
    onQuestionLoadedRef.current = onQuestionLoaded;
  }, [onQuestionLoaded]);

  useEffect(() => {
    if (quest) {
      setLoading(true);
      setDisabled(true);
      setQuestData(null);
      GetMocktestQuestion(quest?.QuestionId).then((res) => {
        if (res?.data) {
          setQuestData(res?.data);
          setLoading(false);
          setDisabled(false);
          onQuestionLoadedRef.current?.();
        } else {
          setLoading(false);
        }
      }).catch((error) => {
        console.error('Error fetching writing question:', error);
        setLoading(false);
      });
    }
  }, [quest]);

  return { questData, loading, disabled, setDisabled };
};
